// Thin API client for the SKU catalog endpoints.
// Public-read (active SKUs) + sku-admin CRUD.
// Uses the shared RequestBuilder for auth + retry handling.

import { RequestBuilder } from "./request";

const PUBLIC_BASE = "/api/sku-catalog";
const ADMIN_BASE  = "/api/admin/sku-catalog";

export const fetchActiveSkus = (authData) =>
  new RequestBuilder(PUBLIC_BASE)
    .withAuthorization(authData)
    .withJSONContentType()
    .fetch();

export const fetchAllSkus = (authData, { includeDeprecated = true } = {}) =>
  new RequestBuilder(`${ADMIN_BASE}?include_deprecated=${includeDeprecated}`)
    .withAuthorization(authData)
    .withJSONContentType()
    .fetch();

export const addSku = (authData, payload) =>
  new RequestBuilder(ADMIN_BASE)
    .withAuthorization(authData)
    .withJSONContentType()
    .asPOST(JSON.stringify(payload))
    .fetch();

export const updateSku = (authData, skuKey, payload) =>
  new RequestBuilder(`${ADMIN_BASE}/${encodeURIComponent(skuKey)}`)
    .withAuthorization(authData)
    .withJSONContentType()
    .asPATCH(JSON.stringify(payload))
    .fetch();

export const deprecateSku = (authData, skuKey) =>
  new RequestBuilder(`${ADMIN_BASE}/${encodeURIComponent(skuKey)}`)
    .withAuthorization(authData)
    .asDELETE()
    .fetch();
